// Строки-объяснения над полем промпта. Живут двумя группами, потому что стоят в
// баре в разных местах: что случилось с набранным — над рядом входов, чего не
// хватает для отправки — под лентой вложений, ближе к кнопке.

import { useTranslation } from "react-i18next";

import { PromptNotice } from "./PromptNotice";

import type { MentionableElement } from "~/shared/lib/element-mentions";

export interface PromptDraftNoticesProps {
    /** Элементы применённого повтора, которых больше нет в библиотеке. */
    missingElements: readonly MentionableElement[];
    /** Сколько референсных картинок повтор не смог перенести. */
    droppedReferenceImages: number;
    /** Элементы, чьё имя совпало со словом промпта. */
    nameCollisions: readonly MentionableElement[];
    promptLength: number;
    promptLimit: number;
}

/** Что случилось с набранным: повтор, коллизии имён, упёршийся в потолок промпт. */
export function PromptDraftNotices({
    missingElements,
    droppedReferenceImages,
    nameCollisions,
    promptLength,
    promptLimit,
}: PromptDraftNoticesProps) {
    const { t } = useTranslation("chat");

    return (
        <>
            {missingElements.length > 0 && (
                <PromptNotice>
                    {t("prompt.elements.removedFromLibrary", {
                        names: missingElements.map((element) => element.name).join(", "),
                        count: missingElements.length,
                    })}
                </PromptNotice>
            )}

            {droppedReferenceImages > 0 && (
                <PromptNotice>
                    {t("prompt.references.notRepeated", { count: droppedReferenceImages })}
                </PromptNotice>
            )}

            {nameCollisions.length > 0 && (
                <PromptNotice>
                    {t("prompt.elements.nameCollision", {
                        names: nameCollisions.map((element) => element.name).join(", "),
                        count: nameCollisions.length,
                    })}
                </PromptNotice>
            )}

            {/* Промпт упёрся в потолок режима: поле дальше не примет, и человек
                должен видеть почему — иначе набранное просто перестаёт вводиться. */}
            {promptLength >= promptLimit && (
                <PromptNotice>{t("prompt.length.atLimit", { limit: promptLimit })}</PromptNotice>
            )}
        </>
    );
}

export interface PromptGateNoticesProps {
    requireFilesTooltip: boolean;
    blockedWithElements: boolean;
    remainingImages: number;
    missingVisualInput: boolean;
    inputsNotExecutable: boolean;
}

/** Чего не хватает для отправки — той же причиной, что гасит кнопку. */
export function PromptGateNotices({
    requireFilesTooltip,
    blockedWithElements,
    remainingImages,
    missingVisualInput,
    inputsNotExecutable,
}: PromptGateNoticesProps) {
    const { t } = useTranslation("chat");

    return (
        <>
            {requireFilesTooltip && (
                <PromptNotice>
                    {blockedWithElements
                        ? t("prompt.requireFrameWithElements")
                        : t("prompt.requireMore", { count: remainingImages })}
                </PromptNotice>
            )}

            {missingVisualInput && !requireFilesTooltip && (
                <PromptNotice>{t("prompt.requireVisualInput")}</PromptNotice>
            )}

            {/* Тултип на погашенной кнопке доступен не всем (тач-экран),
                поэтому причина проговаривается и в баре. */}
            {inputsNotExecutable && !requireFilesTooltip && !missingVisualInput && (
                <PromptNotice>{t("prompt.inputsNotExecutable")}</PromptNotice>
            )}
        </>
    );
}
